import type { PageOpensDay } from '@/types/leaderboards';

/** "12 (40%)": a count and its share of `of`; just the count when `of` is 0. */
export function countWithShare(count: number, of: number): string {
  if (!of) return String(count);
  return `${count} (${Math.round((count / of) * 100)}%)`;
}

/** Seconds as "45 s", "7 min", "3 h 20 min"; "—" when null. */
export function formatAway(sec: number | null): string {
  if (sec === null || !Number.isFinite(sec)) return '—';
  if (sec < 60) return `${Math.round(sec)} s`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const rest = min % 60;
  return rest ? `${h} h ${rest} min` : `${h} h`;
}

/**
 * Visits that did not come back within 24 h and can no longer (their 24 h are over).
 * The still-waiting ones are counted apart, so a fresh day does not look like a loss.
 */
export function notBack(d: PageOpensDay): number {
  return Math.max(0, d.visits - d.back24h - d.pending);
}

/** The sum of the counts over the days (median and players left out: they do not add up across days). */
export function totals(
  days: PageOpensDay[]
): Omit<PageOpensDay, 'day' | 'medianAwaySec' | 'players'> {
  const t = {
    opens: 0,
    visits: 0,
    back5m: 0,
    back30m: 0,
    back24h: 0,
    pending: 0,
    played1h: 0,
    mature1h: 0,
  };
  for (const d of days) {
    t.opens += d.opens;
    t.visits += d.visits;
    t.back5m += d.back5m;
    t.back30m += d.back30m;
    t.back24h += d.back24h;
    t.pending += d.pending;
    t.played1h += d.played1h;
    t.mature1h += d.mature1h;
  }
  return t;
}
